import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public set(key: string, token: string) {
    localStorage.setItem(key, token);
  }

  public remove(key: string) {
    localStorage.removeItem(key);
  }

  public get(key: string): string | null {
    return localStorage.getItem(key);
  }
}
